/**
 * Geocode結果出力クラス
 */
export class GeocodeResult {
  /**
   * 住所
   */
  address: string;
  /**
   * 経度
   */
  longitude: number;
  /**
   * 緯度
   */
  latitude: number;

  /**
   * コンストラクタ
   * @param address 住所文字列
   * @param longitude 経度
   * @param latitude 緯度
   */
  constructor(address: string, longitude: number, latitude: number) {
    this.address = address;
    this.longitude = longitude;
    this.latitude = latitude;
  }
}
